import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-challenge-v005',
  templateUrl: './challenge-v005.component.html',
  styleUrls: ['./challenge-v005.component.scss']
})
export class ChallengeV005Component implements OnInit {

  @Input() timer;

  constructor() { }

  ngOnInit(): void {
  }

}
